import {
  CardContainer,
  CardDetails,
  CardName,
  CardQuantity,
  CardContent,
  SideBar,
  SideList,
} from "./dashboardStyle";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
// import "@fortawesome/fontawesome-free/css/all.min.css";
import { RiDashboardLine, RiNotification4Line } from "react-icons/ri";
import { MdOutlineCategory, MdProductionQuantityLimits } from "react-icons/md";
import {
  AiOutlineSetting,
  AiOutlineStock,
  // AiOutlineShop
} from "react-icons/ai";
import {
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCol,
  MDBRow,
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import axios from "axios";

const fetchProductsByUser = async (key, userId) => {
  return axios.get(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/products/user/${userId}`
  );
};

const fetchCategoriesByUser = async (key, userId) => {
  return axios.get(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/categories/user/${userId}`
  );
};

const updateProduct = async (product) => {
  return axios.patch(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/products/${product._id}`,
    product
  );
};

const deleteProduct = async (productId) => {
  return axios.delete(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/products/${productId}`
  );
};

const addCategory = async (category) => {
  return axios.post(
    "https://ancient-caverns-61891.herokuapp.com/api/v1/categories",
    category
  );
};

const updateCategory = async (category) => {
  return axios.patch(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/categories/${category._id}`,
    category
  );
};

const deleteCategory = async (categoryId) => {
  return axios.delete(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/categories/${categoryId}`
  );
};

const Dashboard = () => {
  const { data, error, isLoading } = useQuery(
    ["products", "60f1b1b0e2b2a30015b8b0a2"],
    fetchProductsByUser
  );

  const {
    data: categories,
    error: errorCategories,
    isLoading: isLoadingCategories,
  } = useQuery(
    ["categories", "60f1b1b0e2b2a30015b8b0a2"],
    fetchCategoriesByUser
  );

  const handleDeleteProduct = async (productId) => {
    await deleteProduct(productId);
    window.location.reload();
  };

  const handleDeleteCategory = async (categoryId) => {
    await deleteCategory(categoryId);
    window.location.reload();
  };

  if (isLoading) return <h1>Loading...</h1>;
  if (isLoadingCategories) return <h1>Loading...</h1>;

  return (
    <CardContainer>
      <SideBar>
        <SideList>
          <Link>
            <RiDashboardLine size={20} color="#3cc380" />
            Dashboard
          </Link>
          <Link>
            <MdProductionQuantityLimits size={20} color="#3cc380" />
            Products
          </Link>
          <Link>
            <MdOutlineCategory size={20} color="#3cc380" />
            Categories
          </Link>
          <Link>
            <RiNotification4Line size={20} color="#3cc380" />
            Notification
          </Link>
          <Link>
            <AiOutlineStock size={20} color="#3cc380" />
            Stock Flow
          </Link>
          <Link>
            <AiOutlineSetting size={20} color="#3cc380" />
            Settings
          </Link>
        </SideList>
      </SideBar>
      <CardDetails>
        <CardContent>
          {/* <div>
                <CardName>
                <MdProductionQuantityLimits /> 
                    Number of Product
                </CardName>
                <CardQuantity> 49</CardQuantity>
                <CardName>
                <AiOutlineShop /> 
                    Categories
                </CardName>
                <CardQuantity> 49</CardQuantity>
            </div> */}

          <MDBRow className=" row-col-1  col-md-9 ">
            <MDBCol>
              <MDBCard>
                <MDBCardBody></MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol>
              <MDBCard>
                <MDBCardBody>
                  <MDBCardTitle className="fs-1">Categories</MDBCardTitle>
                  <MDBCardText className="fs-4">
                    This is a longer card with supporting text below as a
                    natural lead-in to additional content. This content is a
                    little bit longer.
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol>
              <MDBCard>
                <MDBCardBody>
                  <MDBCardTitle className="fs-1">Stocks</MDBCardTitle>
                  <MDBCardText className="fs-4">
                    This is a longer card with supporting text below as a
                    natural lead-in to additional content. This content is a
                    little bit longer.
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </CardContent>
      </CardDetails>
    </CardContainer>
  );
};

export default Dashboard;
